import { MenuItems } from '@/shared/enums/side-menu.enum';
import { UserRole } from '@/shared/enums/user-role.enum';
import { UserTeams } from '@/shared/enums/user-teams.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';

import { MenuIcons } from './menu-icons';

export const PUBLIC_PATH =
  import.meta.env.BASE_URL === '/' ? '' : (import.meta.env.BASE_URL || '').replace(/\/+$/, '');
export const SERVER_BASE_URL = import.meta.env.VITE_BE_API_ENDPOINT;
export const HOST_NAME = '//' + window.location.host.replace(/\/+$/, '');
export const WEBSITE_HOME = import.meta.env.VITE_WEBSITE_BASE || 'https://carofi.app';
export const PARTNER_PORTAL_URL =
  import.meta.env.VITE_PARTNER_PORTAL_BASE || 'https://partner.carofi.app';

if (import.meta.env.DEV) {
  console.group();
  console.info('*** PUBLIC PATH *** ', PUBLIC_PATH);
  console.info('*** SERVER BASE URL *** ', SERVER_BASE_URL);
  console.info('*** HOST NAME ***', HOST_NAME);
  console.info('*** WEBSITE HOME ***', WEBSITE_HOME);
  console.info('*** PARTNER PORTAL URL ***', PARTNER_PORTAL_URL);
  console.groupEnd();
}

export const APP_ROUTES: RouteConfig = {
  AUTH_MODULE: {
    PATH: '/auth',
    FULL_PATH: '/auth',
    NAME: 'auth',
    IS_MENU: false,

    CHILDREN: {
      LOGIN: {
        PATH: '/login',
        FULL_PATH: '/auth/login',
        NAME: 'Sign in',
        IS_MENU: false
      },
      RESET_PASSWORD: {
        PATH: '/reset-password',
        FULL_PATH: '/auth/reset-password',
        NAME: 'Reset password',
        IS_MENU: false
      },
      FORGOT_PASSWORD: {
        PATH: '/forgot-password',
        FULL_PATH: '/auth/forgot-password',
        NAME: 'Forgot password',
        IS_MENU: false
      },
      UNAUTHORIZED: {
        PATH: '/unauthorized',
        FULL_PATH: '/auth/unauthorzied',
        NAME: 'Unauthorized',
        IS_MENU: false
      }
    }
  },
  DASHBOARD_MODULE: {
    PATH: '/dashboard',
    FULL_PATH: '/dashboard',
    DISPLAY_NAME: 'DASHBOARD',
    NAME: 'dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.MARKETING_EXECUTIVE,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.FINANCE_OFFICER,
      UserRole.OPERATION_MANAGER,
      UserRole.HR_REPRESENTATIVE,
      UserRole.HR_MANAGER,
      UserRole.ADMIN
    ],
    ICON: MenuIcons.DASHBOARD_MODULE,
    CHILDREN: {
      HOME: {
        PATH: '/home',
        FULL_PATH: '/dashboard/home',
        NAME: 'Home',
        IS_MENU: false
      }
    }
  },

  CATALOGUE_MODULE: {
    PATH: '/catalogue',
    FULL_PATH: '/catalogue',
    DISPLAY_NAME: 'FINANCE NOW!',
    NAME: 'catalogue',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.FINANCE_OFFICER,
      UserRole.OPERATION_MANAGER,
      UserRole.HR_REPRESENTATIVE,
      UserRole.HR_MANAGER,
      UserRole.ADMIN
    ],
    ICON: MenuIcons.CATALOGUE_MODULE,
    CHILDREN: {
      CALCULATOR: {
        PATH: '/calculator',
        FULL_PATH: '/catalogue/calculator',
        NAME: 'Calculator',
        IS_MENU: false
      }
    }
  },

  COMMUNICATION_MODULE: {
    PATH: '/communication',
    FULL_PATH: '/communication',
    DISPLAY_NAME: 'Messaging',
    NAME: 'communication',
    IS_MENU: false,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT
    ],
    PARENT: MenuItems.COMMUNICATION,
    CHILDREN: {
      CONSUMER_WHATSAPP: {
        PATH: '/consumer-whatsapp',
        FULL_PATH: '/communication/consumer-whatsapp',
        NAME: 'WhatsApp',
        IS_MENU: false
      },
      CONSUMER_FACEBOOK: {
        PATH: '/consumer-facebook',
        FULL_PATH: '/communication/consumer-facebook',
        NAME: 'Facebook Messenger',
        IS_MENU: false
      },
      CONSUMER_INSTAGRAM: {
        PATH: '/consumer-instagram',
        FULL_PATH: '/communication/consumer-instagram',
        NAME: 'Instagram Messenger',
        IS_MENU: false
      },
      CORPORATE_WHATSAPP: {
        PATH: '/corporate-whatsapp',
        FULL_PATH: '/communication/corporate-whatsapp',
        NAME: 'Corporate WhatsApp',
        IS_MENU: false
      }
    }
  },
  CONSUMER_WHATSAPP_MODULE: {
    PATH: '/consumer-whatsapp',
    FULL_PATH: '/communication/consumer-whatsapp',
    DISPLAY_NAME: 'Whatsapp',
    NAME: 'communication',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT
    ],
    PARENT: MenuItems.COMMUNICATION
  },
  CONSUMER_FACEBOOK_MODULE: {
    PATH: '/consumer-facebook',
    FULL_PATH: '/communication/consumer-facebook',
    DISPLAY_NAME: 'Facebook Messenger',
    NAME: 'communication',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER],
    PARENT: MenuItems.COMMUNICATION
  },
  CONSUMER_INSTAGRAM_MODULE: {
    PATH: '/consumer-instagram',
    FULL_PATH: '/communication/consumer-instagram',
    DISPLAY_NAME: 'Instagram Messenger',
    NAME: 'communication',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER],
    PARENT: MenuItems.COMMUNICATION
  },
  CORPORATE_WHATSAPP_MODULE: {
    PATH: '/corporate-whatsapp',
    FULL_PATH: '/communication/corporate-whatsapp',
    DISPLAY_NAME: 'Corporate Whatsapp',
    NAME: 'communication',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT
    ],
    PARENT: MenuItems.COMMUNICATION
  },

  TRANSACTIONS_MODULE: {
    PATH: '/transactions',
    FULL_PATH: '/transactions',
    DISPLAY_NAME: 'Transactions',
    NAME: 'transactions',
    IS_MENU: true,
    PARENT: MenuItems.OPERATIONS,
    ICON: MenuIcons.OPERATIONS,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.FINANCE_OFFICER],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/transactions/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/transactions/details',
        FULL_PATH: '/transactions/details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/transactions/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/transactions/edit',
        FULL_PATH: '/transactions/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },
  PURCHASES_MODULE: {
    PATH: '/purchase-orders',
    FULL_PATH: '/purchase-orders',
    DISPLAY_NAME: 'Purchase orders',
    NAME: 'purchase-orders',
    IS_MENU: true,
    PARENT: MenuItems.OPERATIONS,
    ICON: MenuIcons.OPERATIONS,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.FINANCE_OFFICER,
      UserRole.OPERATION_MANAGER,
      UserRole.OPERATION_AGENT
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/purchase-orders/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/purchase-orders/details',
        FULL_PATH: '/purchase-orders/details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/purchase-orders/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/purchase-orders/edit',
        FULL_PATH: '/purchase-orders/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },
  WALLETS_MODULE: {
    PATH: '/wallets',
    FULL_PATH: '/wallets',
    DISPLAY_NAME: 'Wallets',
    NAME: 'wallets',
    IS_MENU: true,
    PARENT: MenuItems.OPERATIONS,
    ICON: MenuIcons.OPERATIONS,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.FINANCE_OFFICER],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/wallets/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/details',
        FULL_PATH: '/wallets/details/:id',
        NAME: 'Details',
        IS_MENU: false
      }
    }
  },
  CASH_OUT_MODULE: {
    PATH: '/cashouts',
    FULL_PATH: '/cashouts',
    DISPLAY_NAME: 'Cash outs',
    NAME: 'cashouts',
    IS_MENU: true,
    PARENT: MenuItems.OPERATIONS,
    ICON: MenuIcons.OPERATIONS,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.FINANCE_OFFICER],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/cashouts/list',
        NAME: 'List',
        IS_MENU: false
      },
      CREATE: {
        PATH: '/create',
        FULL_PATH: '/cashouts/create',
        NAME: 'Create',
        IS_MENU: false
      },
      DETAILS: {
        PATH: '/details',
        FULL_PATH: '/cashouts/details/:id',
        NAME: 'Details',
        IS_MENU: false
      }
    }
  },
  CASH_IN_MODULE: {
    PATH: '/cashins',
    FULL_PATH: '/cashins',
    DISPLAY_NAME: 'Cash ins',
    NAME: 'cashins',
    IS_MENU: true,
    PARENT: MenuItems.OPERATIONS,
    ICON: MenuIcons.OPERATIONS,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.FINANCE_OFFICER],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/cashins/list',
        NAME: 'List',
        IS_MENU: false
      },
      DETAILS: {
        PATH: '/details',
        FULL_PATH: '/cashins/details/:id',
        NAME: 'Details',
        IS_MENU: false
      }
    }
  },

  FINANCE_APPLICATIONS_DASHBOARD_MODULE: {
    PATH: '/finance-applications/dashboard',
    FULL_PATH: '/finance-applications/dashboard',
    DISPLAY_NAME: 'Applications Dashboard',
    NAME: 'finance-applications/dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SALES_MANAGER, UserRole.SALES_AGENT],
    PARENT: MenuItems.REQUESTS
  },
  FINANCE_APPLICATIONS_MODULE: {
    PATH: '/finance-applications',
    FULL_PATH: '/finance-applications',
    DISPLAY_NAME: 'Finance Applications',
    NAME: 'finance-applications',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.OPERATION_MANAGER,
      UserRole.FINANCE_OFFICER
    ],
    PARENT: MenuItems.REQUESTS,
    CHILDREN: {
      DASHBOARD: {
        PATH: '/dashboard',
        FULL_PATH: '/finance-applications/dashboard',
        NAME: 'Finance Applications Dashboard',
        IS_MENU: true,
        PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SALES_MANAGER]
      },
      LIST: {
        PATH: '/list',
        FULL_PATH: '/finance-applications/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/finance-applications/details',
        FULL_PATH: '/finance-applications/details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/finance-applications/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/finance-applications/edit',
        FULL_PATH: '/finance-applications/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },
  SERVICE_CENTER_REQUESTS_MODULE: {
    PATH: '/service-center-requests',
    FULL_PATH: '/service-center-requests',
    DISPLAY_NAME: 'Service Center Requests',
    NAME: 'service-center-requests',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN],
    PARENT: MenuItems.REQUESTS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/service-center-requests/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/service-center-requests/details',
        FULL_PATH: '/service-center-requests/details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/service-center-requests/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/service-center-requests/edit',
        FULL_PATH: '/service-center-requests/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },

  LEADS_DASHBOARD_MODULE: {
    PATH: '/leads/dashboard',
    FULL_PATH: '/leads/dashboard',
    DISPLAY_NAME: 'Agents Dashboard',
    NAME: 'leads/dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.MARKETING_EXECUTIVE
    ],
    PERMITTED_TEAMS: [UserTeams.DIGITAL, UserTeams.E_COMMERCE],
    PARENT: MenuItems.LEADS
  },
  LEADS_ATTRIBUTION_DASHBOARD_MODULE: {
    PATH: '/leads/attribution-dashboard',
    FULL_PATH: '/leads/attribution-dashboard',
    DISPLAY_NAME: 'Attribution Dashboard',
    NAME: 'leads/attribution-dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.MARKETING_EXECUTIVE
    ],
    PERMITTED_TEAMS: [UserTeams.DIGITAL, UserTeams.E_COMMERCE],
    PARENT: MenuItems.LEADS
  },
  LEADS_MODULE: {
    PATH: '/leads',
    FULL_PATH: '/leads',
    DISPLAY_NAME: 'Leads',
    NAME: 'leads',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.MARKETING_EXECUTIVE
    ],
    PERMITTED_TEAMS: [UserTeams.DIGITAL, UserTeams.E_COMMERCE],
    PARENT: MenuItems.LEADS,
    CHILDREN: {
      DASHBOARD: {
        PATH: '/dashboard',
        FULL_PATH: '/leads/dashboard',
        NAME: 'Agents Dashboard',
        IS_MENU: true
      },
      ATTRIBUTION_DASHBOARD: {
        PATH: '/attribution-dashboard',
        FULL_PATH: '/leads/attribution-dashboard',
        NAME: 'Attribution Dashboard',
        IS_MENU: true
      },
      LIST: {
        PATH: '/list',
        FULL_PATH: '/leads/list',
        NAME: 'List',
        IS_MENU: true,
        PERMITTED_ROLES: [
          UserRole.ADMIN,
          UserRole.SALES_AGENT,
          UserRole.SALES_MANAGER,
          UserRole.SALES_QUALITY_MANAGER,
          UserRole.SALES_QUALITY_AGENT,
          UserRole.E_COMMERCE_AUTO,
          UserRole.E_COMMERCE_MANAGER
        ]
      },
      DETAILS: {
        PATH: '/lead-details',
        FULL_PATH: '/leads/lead-details/:id',
        NAME: 'Details',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/leads/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/edit',
        FULL_PATH: '/leads/edit/:id',
        NAME: 'Edit',
        IS_MENU: false
      }
    }
  },
  CUSTOMER_ANALYTICS_MODULE: {
    PATH: '/customers/analytics',
    FULL_PATH: '/customers/analytics',
    DISPLAY_NAME: 'Customers Dashboard',
    NAME: 'customer-analytics',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.SALES_MANAGER,
      UserRole.SALES_AGENT,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.OPERATION_MANAGER,
      UserRole.MARKETING_EXECUTIVE
    ],
    PARENT: MenuItems.CUSTOMERS
  },

  CUSTOMERS_MODULE: {
    PATH: '/customers',
    FULL_PATH: '/customers',
    DISPLAY_NAME: 'Profiles',
    NAME: 'customers',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.OPERATION_MANAGER,
      UserRole.FINANCE_OFFICER
    ],
    PARENT: MenuItems.CUSTOMERS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/customers/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/customers/customer-details',
        FULL_PATH: '/customers/customer-details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/customers/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/customers/edit',
        FULL_PATH: '/customers/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      },
      FINANCE_APPLICATION_DETAILS: {
        PATH: 'customers/customer-details/finance-application',
        FULL_PATH: '/customers/customer-details/:customerId/finance-application/:applicationId',
        NAME: 'List finance applications',
        IS_MENU: false
      },
      ADD_FINANCE_APPLICATION: {
        PATH: 'customers/customer-details/:customerId/finance-application/add',
        FULL_PATH: '/customers/customer-details/:customerId/finance-application/add',
        NAME: 'Add finance application',
        IS_MENU: false
      },
      EDIT_FINANCE_APPLICATION: {
        PATH: 'customers/customer-details/:customerId/finance-application/edit',
        FULL_PATH:
          '/customers/customer-details/:customerId/finance-application/edit/:applicationId',
        NAME: 'Edit finance application',
        IS_MENU: false
      }
    }
  },

  MERCHANT_MODULE: {
    PATH: '/merchants',
    FULL_PATH: '/merchants',
    DISPLAY_NAME: 'Merchants',
    NAME: 'merchants',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_AUTO
    ],
    PARENT: MenuItems.PARTNERS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/merchants/list',
        NAME: 'List',
        IS_MENU: true
      },
      AUTO_DETAILS: {
        PATH: '/merchants/auto-details',
        FULL_PATH: '/merchants/auto-details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/merchants/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/merchants/edit',
        FULL_PATH: '/merchants/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },
  REFERRALS_MODULE: {
    PATH: '/referrals',
    FULL_PATH: '/referrals',
    DISPLAY_NAME: 'Referrals',
    NAME: 'referrals',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.OPERATION_MANAGER,
      UserRole.E_COMMERCE_REFERRAL,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.FINANCE_OFFICER
    ],
    PARENT: MenuItems.PARTNERS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/referrals/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/referrals/details',
        FULL_PATH: '/referrals/details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/referrals/add',
        FULL_PATH: '/referrals/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/referrals/edit',
        FULL_PATH: '/referrals/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },

  REFERRAL_TRACKING_DASHBOARD_MODULE: {
    PATH: '/referrals/tracking-dashboard',
    FULL_PATH: '/referrals/tracking-dashboard',
    DISPLAY_NAME: 'Referral Dashboard',
    NAME: 'referral-tracking-dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.OPERATION_MANAGER,
      UserRole.OPERATION_AGENT,
      UserRole.E_COMMERCE_REFERRAL,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.MARKETING_EXECUTIVE,
      UserRole.FINANCE_OFFICER
    ],
    PARENT: MenuItems.PARTNERS
  },

  PRODUCTS_MODULE: {
    PATH: '/products',
    FULL_PATH: '/products',
    DISPLAY_NAME: 'Auto products',
    NAME: 'products',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_AUTO, UserRole.E_COMMERCE_MANAGER],
    PARENT: MenuItems.PRODUCTS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/products/list',
        NAME: 'List',
        IS_MENU: true
      },
      ADD_AUTO: {
        PATH: '/add/auto',
        FULL_PATH: '/products/add/auto',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT_AUTO: {
        PATH: '/products/edit/auto',
        FULL_PATH: '/products/edit/auto/:id',
        NAME: 'edit',
        IS_MENU: false
      },
      VIEW_AUTO: {
        PATH: '/products/view/auto',
        FULL_PATH: '/products/view/auto/:id',
        NAME: 'view',
        IS_MENU: false
      },
      AUTO_MARKETPLACE_ANALYTICS: {
        PATH: '/auto-marketplace-analytics',
        FULL_PATH: '/products/auto-marketplace-analytics',
        NAME: 'Marketplace Analytics',
        DISPLAY_NAME: 'Marketplace Analytics',
        IS_MENU: true,
        ICON: MenuIcons.PRODUCTS
      }
    }
  },
  AUTO_MARKETPLACE_MODULE: {
    PATH: '/auto-marketplace-analytics',
    FULL_PATH: '/products/auto-marketplace-analytics',
    DISPLAY_NAME: 'Auto Marketplace Dashboard',
    NAME: 'auto-marketplace-analytics',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_AUTO, UserRole.E_COMMERCE_MANAGER],
    PARENT: MenuItems.PRODUCTS
  },
  FINANCIAL_PRODUCTS_MODULE: {
    PATH: '/financial-products',
    FULL_PATH: '/financial-products',
    DISPLAY_NAME: 'Financial products',
    NAME: 'financial-products',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.FINANCE_OFFICER,
      UserRole.OPERATION_MANAGER
    ],
    PARENT: MenuItems.PRODUCTS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/financial-products/list',
        NAME: 'FinList',
        IS_MENU: true
      },
      ADD_FINANCIAL_PRODUCT: {
        PATH: '/add/financial-products',
        FULL_PATH: '/financial-products/add',
        NAME: 'FinAdd',
        IS_MENU: false
      },
      EDIT_FINANCIAL_PRODUCT: {
        PATH: '/financial-products/edit',
        FULL_PATH: '/financial-products/edit/:id',
        NAME: 'FinEdit',
        IS_MENU: false
      }
    }
  },
  SERVICE_CENTER_PRODUCTS_MODULE: {
    PATH: '/service-center-products',
    FULL_PATH: '/service-center-products',
    DISPLAY_NAME: 'Service center products',
    NAME: 'service-center-products',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER],
    PARENT: MenuItems.PRODUCTS,
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/service-center-products/list',
        NAME: 'List',
        IS_MENU: true
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/service-center-products/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/service-center-products/edit',
        FULL_PATH: '/service-center-products/edit/:id',
        NAME: 'Edit',
        IS_MENU: false
      },
      DETAILS: {
        PATH: '/service-center-products/details',
        FULL_PATH: '/service-center-products/details/:id',
        NAME: 'Details',
        IS_MENU: false
      }
    }
  },

  REPORTS_MODULE: {
    PATH: '/reports',
    FULL_PATH: '/reports',
    DISPLAY_NAME: 'Finance Applications',
    NAME: 'reports',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SALES_MANAGER, UserRole.FINANCE_OFFICER],
    PARENT: MenuItems.REPORTS,
    CHILDREN: {
      FINANCE_APPLICATIONS_REPORT_FILTER: {
        PATH: '/filter',
        FULL_PATH: '/reports/finance-application-report/filter',
        NAME: 'Finance Applications Report Filter',
        IS_MENU: true
      },
      FINANCE_APPLICATIONS_REPORT: {
        PATH: '/list',
        FULL_PATH: '/reports/finance-application-report/list',
        NAME: 'Finance Applications Report',
        IS_MENU: true
      }
    }
  },
  PURCHASE_ORDERS_REPORT_MODULE: {
    PATH: '/purchase-report',
    FULL_PATH: '/purchase-report',
    DISPLAY_NAME: 'Purchase Orders',
    NAME: 'purchase-report',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SALES_MANAGER, UserRole.FINANCE_OFFICER],
    PARENT: MenuItems.REPORTS,
    CHILDREN: {
      FILTER: {
        PATH: '/filter',
        FULL_PATH: '/purchase-report/filter',
        NAME: 'Purchase Orders Report Filter',
        IS_MENU: true
      },
      LIST: {
        PATH: '/list',
        FULL_PATH: '/purchase-report/list',
        NAME: 'Purchase Orders Report',
        IS_MENU: true
      }
    }
  },

  USER_MANAGEMENT_MODULE: {
    PATH: '/user-management',
    FULL_PATH: '/user-management',
    DISPLAY_NAME: 'Accounts',
    NAME: 'user-management',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.ADMIN,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.HR_REPRESENTATIVE,
      UserRole.HR_MANAGER,
      UserRole.HELP_DESK_SUPPORT
    ],
    PARENT: MenuItems.USERS,
    CHILDREN: {
      LIST: {
        PATH: '/user-management',
        FULL_PATH: '/user-management/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/user-management/details',
        FULL_PATH: '/user-management/details/:id',
        NAME: 'List',
        IS_MENU: false
      },
      ADD: {
        PATH: '/add',
        FULL_PATH: '/user-management/add',
        NAME: 'Add',
        IS_MENU: false
      },
      EDIT: {
        PATH: '/user-management/edit',
        FULL_PATH: '/user-management/edit/:id',
        NAME: 'edit',
        IS_MENU: false
      }
    }
  },

  SALES_MANAGEMENT_MODULE: {
    PATH: '/sales-management',
    FULL_PATH: '/sales-management',
    DISPLAY_NAME: 'Teams',
    NAME: 'teams',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN],
    PARENT: MenuItems.SALES,
    CHILDREN: {
      TEAMS_LIST: {
        PATH: '/sales-management/teams',
        FULL_PATH: '/sales-management/teams/list',
        NAME: 'List',
        IS_MENU: true
      },
      TEAMS_ADD: {
        PATH: '/sales-management/teams/add',
        FULL_PATH: '/sales-management/teams/add',
        NAME: 'Add',
        IS_MENU: false
      },
      TEAMS_EDIT: {
        PATH: '/sales-management/teams/edit',
        FULL_PATH: '/sales-management/teams/edit',
        NAME: 'edit',
        IS_MENU: false
      },
      TEAM_MEMBER_DETAILS: {
        PATH: '/sales-management/teams/member',
        FULL_PATH: '/sales-management/teams/member/:id',
        NAME: 'member-details',
        IS_MENU: false
      },
      KPIS: {
        PATH: '/sales-management/teams/kpis',
        FULL_PATH: '/sales-management/teams/kpis',
        NAME: 'kpis',
        IS_MENU: true
      },
      COMMISSION_SCHEME: {
        PATH: '/commission-scheme',
        FULL_PATH: '/sales-management/commission-scheme',
        NAME: 'commission-scheme',
        IS_MENU: true
      },
      ARCHIVE: {
        PATH: '/archive',
        FULL_PATH: '/sales-management/archive',
        NAME: 'archive',
        IS_MENU: true
      }
    }
  },
  COMMISSION_SCHEME_MODULE: {
    PATH: '/sales-management/commission-scheme',
    FULL_PATH: '/sales-management/commission-scheme',
    DISPLAY_NAME: 'Commission scheme',
    NAME: 'commission-scheme',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN],
    PARENT: MenuItems.SALES
  },
  ARCHIVE_MODULE: {
    PATH: '/sales-management/archive',
    FULL_PATH: '/sales-management/archive',
    DISPLAY_NAME: 'Archive',
    NAME: 'archive',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN],
    PARENT: MenuItems.SALES,
    CHILDREN: {
      LIST: {
        PATH: '/sales-management/archive',
        FULL_PATH: '/sales-management/archive/list',
        NAME: 'List',
        IS_MENU: true
      },
      DETAILS: {
        PATH: '/sales-management/archive',
        FULL_PATH: '/sales-management/archive/:id',
        NAME: 'details',
        IS_MENU: false
      }
    }
  },

  BRANDS_MODULE: {
    PATH: '/configuration/brands',
    FULL_PATH: '/configuration/brands',
    DISPLAY_NAME: 'Auto brands',
    NAME: 'brands',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER],
    PARENT: MenuItems.SETTINGS,
    CHILDREN: {
      BRANDS_LIST: {
        PATH: '/configuration/brands/list',
        FULL_PATH: '/configuration/brands/list',
        NAME: 'BrandsList',
        IS_MENU: true,
        PERMITTED_ROLES: [UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER]
      }
    }
  },
  ATTENDANCE_MODULE: {
    PATH: '/attendance',
    FULL_PATH: '/attendance',
    DISPLAY_NAME: 'ATTENDANCE',
    NAME: 'attendance',
    IS_MENU: false,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER],
    ICON: MenuIcons.ATTENDANCE,
    CHILDREN: {
      DASHBOARD: {
        PATH: 'dashboard',
        FULL_PATH: '/attendance/dashboard',
        NAME: 'Dashboard',
        IS_MENU: false,
        PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER]
      },
      RAW_ENTRIES: {
        PATH: 'raw-entries',
        FULL_PATH: '/attendance/raw-entries',
        NAME: 'Raw Entries',
        IS_MENU: false,
        PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER]
      },
      PROCESSED_DATA: {
        PATH: 'processed-data',
        FULL_PATH: '/attendance/processed-data',
        NAME: 'Processed Data',
        IS_MENU: false,
        PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER]
      }
    }
  },
  ATTENDANCE_DASHBOARD: {
    PATH: '/attendance/dashboard',
    FULL_PATH: '/attendance/dashboard',
    DISPLAY_NAME: 'Dashboard',
    NAME: 'Dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER],
    PARENT: MenuItems.ATTENDANCE
  },
  ATTENDANCE_RAW_ENTRIES: {
    PATH: '/attendance/raw-entries',
    FULL_PATH: '/attendance/raw-entries',
    DISPLAY_NAME: 'Raw Entries',
    NAME: 'Raw Entries',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER],
    PARENT: MenuItems.ATTENDANCE
  },
  ATTENDANCE_PROCESSED_DATA: {
    PATH: '/attendance/processed-data',
    FULL_PATH: '/attendance/processed-data',
    DISPLAY_NAME: 'Processed Data',
    NAME: 'Processed Data',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER],
    PARENT: MenuItems.ATTENDANCE
  },
  // HR / Leave module — proxies the standalone horilla HR system through the
  // BFF so internal employees who do not have google accounts can still file,
  // track and manage their own leave requests from client.web.admin.
  HR_MODULE: {
    PATH: '/hr',
    FULL_PATH: '/hr',
    DISPLAY_NAME: 'HR',
    NAME: 'HR',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.MARKETING_EXECUTIVE,
      UserRole.FINANCE_OFFICER,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_SERVICE_CENTER,
      UserRole.E_COMMERCE_REFERRAL,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.OPERATION_MANAGER,
      UserRole.OPERATION_AGENT,
      UserRole.ADMIN,
      UserRole.HR_REPRESENTATIVE,
      UserRole.HR_MANAGER
    ],
    ICON: MenuIcons[MenuItems.HR],
    PARENT: MenuItems.HR,
    CHILDREN: {
      LEAVE_REQUESTS_LIST: {
        PATH: '/hr/leave-requests',
        FULL_PATH: '/hr/leave-requests',
        DISPLAY_NAME: 'Leave Requests',
        NAME: 'Leave Requests',
        IS_MENU: true,
        PARENT: MenuItems.HR
      },
      LEAVE_REQUEST_DETAILS: {
        PATH: '/hr/leave-requests/:id',
        FULL_PATH: '/hr/leave-requests/:id',
        NAME: 'Leave Request Details',
        IS_MENU: false
      },
      LEAVE_DASHBOARD: {
        PATH: '/hr/leave-dashboard',
        FULL_PATH: '/hr/leave-dashboard',
        DISPLAY_NAME: 'Leave Dashboard',
        NAME: 'Leave Dashboard',
        IS_MENU: true,
        PARENT: MenuItems.HR
      },
      TEAM_LEAVE_REQUESTS: {
        PATH: '/hr/team-leave-requests',
        FULL_PATH: '/hr/team-leave-requests',
        DISPLAY_NAME: 'Team Requests',
        NAME: 'Team Leave Requests',
        IS_MENU: true,
        PARENT: MenuItems.HR
      }
    }
  },
  HELPDESK_MODULE: {
    PATH: '/helpdesk',
    FULL_PATH: '/helpdesk',
    DISPLAY_NAME: 'HELPDESK',
    NAME: 'helpdesk',
    IS_MENU: false,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.MARKETING_EXECUTIVE,
      UserRole.FINANCE_OFFICER,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_SERVICE_CENTER,
      UserRole.E_COMMERCE_REFERRAL,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.OPERATION_MANAGER,
      UserRole.OPERATION_AGENT,
      UserRole.HR_REPRESENTATIVE,
      UserRole.HR_MANAGER,
      UserRole.HELP_DESK_SUPPORT
    ],
    PARENT: MenuItems.HELPDESK,
    CHILDREN: {
      DASHBOARD: {
        PATH: '/dashboard',
        FULL_PATH: '/helpdesk/dashboard',
        NAME: 'HelpdeskDashboard',
        IS_MENU: true
      },
      ALL_TICKETS: {
        PATH: '/list',
        FULL_PATH: '/helpdesk/list',
        NAME: 'AllTickets',
        IS_MENU: true
      },
      MY_TICKETS: {
        PATH: '/my-tickets',
        FULL_PATH: '/helpdesk/my-tickets',
        NAME: 'MyTickets',
        IS_MENU: true
      },
      NEW_TICKET: {
        PATH: '/new',
        FULL_PATH: '/helpdesk/new',
        NAME: 'NewTicket',
        IS_MENU: false
      },
      DETAIL: {
        PATH: '/detail/:id',
        FULL_PATH: '/helpdesk/detail/:id',
        NAME: 'TicketDetail',
        IS_MENU: false
      }
    }
  },
  HELPDESK_DASHBOARD: {
    PATH: '/helpdesk/dashboard',
    FULL_PATH: '/helpdesk/dashboard',
    DISPLAY_NAME: 'Helpdesk Dashboard',
    NAME: 'helpdesk/dashboard',
    IS_MENU: true,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.HELP_DESK_SUPPORT],
    PARENT: MenuItems.HELPDESK
  },
  HELPDESK_ALL_TICKETS: {
    PATH: '/helpdesk/list',
    FULL_PATH: '/helpdesk/list',
    DISPLAY_NAME: 'All Tickets',
    NAME: 'list',
    IS_MENU: false,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
    PARENT: MenuItems.HELPDESK
  },
  HELPDESK_MY_TICKETS: {
    PATH: '/helpdesk/my-tickets',
    FULL_PATH: '/helpdesk/my-tickets',
    DISPLAY_NAME: 'My Tickets',
    NAME: 'my-tickets',
    IS_MENU: true,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.SALES_AGENT,
      UserRole.SALES_MANAGER,
      UserRole.SALES_QUALITY_MANAGER,
      UserRole.SALES_QUALITY_AGENT,
      UserRole.MARKETING_EXECUTIVE,
      UserRole.FINANCE_OFFICER,
      UserRole.E_COMMERCE_AUTO,
      UserRole.E_COMMERCE_FINANCE,
      UserRole.E_COMMERCE_SERVICE_CENTER,
      UserRole.E_COMMERCE_REFERRAL,
      UserRole.E_COMMERCE_MANAGER,
      UserRole.OPERATION_MANAGER,
      UserRole.OPERATION_AGENT,
      UserRole.HR_REPRESENTATIVE,
      UserRole.HR_MANAGER,
      UserRole.HELP_DESK_SUPPORT
    ],
    PARENT: MenuItems.HELPDESK
  }
};
